import { Avatar, Box, CardContent, Grid, Typography } from '@mui/material';
import { FC, useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import CardData from "../CardData/CardData";
import { fetchUserById } from "../../store/userThunk";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';

const UserBasicInfo: FC<any> = (props: { userId: any }) => {

  const userId = props.userId;

  const dispatch = useAppDispatch();
  // const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState<any>({});

  const { userById } = useAppSelector(state => state.users);

  // const cardClicked = () => {
  //   handleOpen();
  // }

  const getData = (data: any): any => {
    const { name, email, isEmailVerified, role, isActive } = data;
    return {
      'name': { value: name, title: 'Name' },
      'email': { value: email, title: 'Email' },
      'isEmailVerified': { value: isEmailVerified ? 'Yes': 'No', title: 'Email Verified' },
      'isActive': { value: isActive ? 'Yes': 'No', title: 'Active' },
      'role': { value: role?.role, title: 'Role' },
    };
  };

  const getCardData = () => {
    const data = [];
    if (userData) {
      for (const key in userData) {
        data.push(<CardData key={key} card={userData[key as any]} />)
      }
    }
    return data;
  }

  // const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserById(userId));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    if (userById) {
      setUserData(getData(userById));
    }
  }, [userById]);

  return (
    <>
      <StyledCard sx={{marginLeft:'-5px'}}>
        <Typography variant="h5" component="div">
          <Box sx={{marginLeft:'8px'}}>Company Profile</Box>
          {/* <EditIcon onClick={cardClicked} sx={{ marginLeft: 'auto' }} fontSize='small' /> */}
        </Typography>
        <CardContent>
          <Grid container>
            {userById?.profilePic && <Grid  sx={{width:'100%',display:'flex', justifyContent:'center'}}><Avatar
              alt={'BI'}
              imgProps={{ "referrerPolicy": 'no-referrer'}}
              src={`${userById?.profilePic}`}
              style={{ width: '50px', height: '50px' }}
            /></Grid>}
            {Object.keys(userData).length && getCardData()}
          </Grid>
        </CardContent>
      </StyledCard>
    </>
  );
};

export default UserBasicInfo;
